import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { DisclaimerSubmission } from "../types/panel.type";

export const useSubmitDisclaimer = (rfxId: number, evalId: number) => {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (params: { memberId: number; payload: DisclaimerSubmission }) =>
			apiV2.post(
				`/rfx/${rfxId}/evaluation/${evalId}/panel-members/${params.memberId}/disclaimer`,
				params.payload
			),
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ["panel-members"] });
		},
	});
};
